import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <section
      className="relative flex flex-col items-center justify-center min-h-screen px-4 py-16 overflow-hidden text-center text-white sm:py-20 lg:py-24"
      style={{ fontFamily: 'Inter, sans-serif' }}
    >
      {/* Background elements for visual interest */}
      <div className="absolute inset-0 z-0 opacity-20">
        {/* Replace with an actual cosmic background image or animation */}
        <div className="absolute top-0 left-0 w-full h-full bg-center bg-cover" style={{ backgroundImage: 'url("https://images.unsplash.com/photo-1514790193030-c89d266d7890?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80")' }}></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a1a] via-transparent to-[#0a0a1a]"></div>
      </div>
      
      {/* Content Wrapper for better stacking on small screens */}
      <div className="relative z-10 max-w-6xl mx-auto">
        <motion.h1
          className="px-4 mb-6 text-6xl font-extrabold leading-tight tracking-tight text-transparent sm:text-7xl md:text-8xl lg:text-9xl sm:mb-8 bg-clip-text bg-gradient-to-r from-teal-400 to-blue-600"
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
        >
          LUMORA
        </motion.h1>

        <motion.h2
          className="max-w-4xl px-4 mx-auto mb-8 text-2xl font-light text-teal-200 sm:text-3xl md:text-4xl"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 1 }}
        >
          Unveil the Universe: Your Cosmic Adventure Awaits.
        </motion.h2>

        <motion.p
          className="max-w-3xl px-4 mx-auto mb-10 text-lg text-gray-300 sm:text-xl md:text-2xl sm:mb-12"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 0.8 }}
        >
          Explore stellar insights, converse with an AI companion, and let the lamp guide your starry journey.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 2.0, duration: 0.8 }}
        >
          <Link to="/details">
            <button
              className="mt-6 sm:mt-8 px-10 py-4 sm:px-12 sm:py-5 bg-gradient-to-r from-blue-600 to-teal-500 rounded-full text-white font-bold text-xl sm:text-2xl uppercase tracking-wider transition-all duration-300
                         shadow-xl shadow-teal-500/50 hover:shadow-blue-400/50 transform hover:scale-[1.05] hover:ring-4 ring-offset-2 ring-teal-500 ring-offset-[#0a0a1a]"
            >
              Launch Your Adventure
            </button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}